export class CppForm {
    Id: number;
    StatusId: number;
    AppUserId: number;
    LastUpdateDate: Date;
    LastSubmitDate: Date;
    RevisionComment: string;

    ProjectTitle: string;
    LeadHubId: number;
    CollaboratingHubIds: string;
    CommunicateUpdatesIds: string;
    ProposalUploadId: string;

    static getDefault(): CppForm {
        let form: CppForm = {
            Id: 0,
            StatusId: 0,
            AppUserId: 0,
            LastUpdateDate: new Date(1,1,1),
            LastSubmitDate: new Date(1, 1, 1),
            RevisionComment: "",
            ProjectTitle: "",
            LeadHubId: 0,
            CollaboratingHubIds: "",
            CommunicateUpdatesIds: "",
            ProposalUploadId: ""
        }

        return form;
    }
}